import { Button as AntButton, Modal, Select } from 'antd';
import _ from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPgSetting } from '../../../api/campuses.api';
import { createTossPaymentTodo, getEventOrderInfo } from '../../../api/payments.api';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import useToss from '../../../hooks/useToss';
import { campusHeadOffice } from '../../../lib/data';
import { getInstallment } from '../../../lib/util';
import { IGetPgSetting } from '../../../models/campuses.model';
import { IEventInfo, IEventRegister } from '../../../models/events.model';
import { IGetEventOrderInfo } from '../../../models/payments.model';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import StudentPaymentProcessModal from '../../student/student/modals/PaymentProcessModal';


interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  paymentSelects: number[];
  data1: IEventInfo | undefined;
  data2: IEventRegister[] | undefined;
  doGetEventRegister: () => void;
}

const ConfirmPaymentModal: FC<IProps> = ({
  visible,
  setVisible,
  paymentSelects,
  data1,
  data2,
  doGetEventRegister,
}) => {
  const { t } = useTranslation();
  const selectInstallment: string[] = [t('event.education.column35'), ...getInstallment()];
  const { successNotification } = useNotification();
  const { data: tossRes, isLoading: tossIsLoading, error: tossError, execute: tossExecute } = useToss();
  const { data: res, isLoading, error, execute } = useAxios<IGetEventOrderInfo>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetPgSetting>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios();

  const [installment, setInstallment] = useState(`${t('event.education.column35')}`);
  const [orderInfo, setOrderInfo] = useState<any>();
  const [paymentProcessVisible, setPaymentProcessVisible] = useState(false);

  useEffect(() => {
    if (res?.data && !isLoading && res2?.data && !isLoading2) {
      setOrderInfo(res.data);
      setPaymentProcessVisible(true);
      tossExecute(
        String(res.data.orderId),
        res.data.price,
        installment,
        res2.data.posMid,
        res.data.taxAmt,
        0,
        res.data.orderName,
      );
    }
  }, [res, isLoading, res2, isLoading2]);

  useEffect(() => {
    if (tossRes && !tossIsLoading && orderInfo) {
      const _tossRes: any = _.cloneDeep(tossRes);
      Object.keys(_tossRes).forEach((key: any) => {
        _tossRes[key.toLowerCase()] = _tossRes[key];
        delete _tossRes[key];
      });
      execute3(createTossPaymentTodo({
        ..._tossRes,
        oid: orderInfo.orderId,
        tamt: orderInfo.price,
      }));
    }
  }, [tossRes, tossIsLoading]);

  useEffect(() => {
    if (res3 && !isLoading3) {
      doGetEventRegister();
      successNotification(t('event.education.message12'));
      setPaymentProcessVisible(false);
      setVisible(false);
    }
  }, [res3, isLoading3]);

  useEffect(() => {
    if (tossError) {
      alert(t('event.education.message13'));
      setPaymentProcessVisible(false);
    }
  }, [tossError]);

  const onClose = () => setVisible(false);

  const onGetOrderInfo = () => {
    execute(getEventOrderInfo({
      eventRequireCodes: paymentSelects,
      paymentMtdCode: 'CD',
      paymentChannelCode: 'PO',
    }));
    execute2(getPgSetting(campusHeadOffice));
  };

  const getPaymentInfo = (eventRequireCode: number, key: 'memKorName'|'campusKorName') => {
    if (data2) {
      const result = data2.find((item: IEventRegister) => item.eventRequireCode === eventRequireCode,);
      if (result) {
        return result[key];
      }
    }

    return '';
  };

  return (
    <>
      {isLoading || isLoading2 || isLoading3 || tossIsLoading ? (
        <Loader />
      ) : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />

      <Modal
        title={t('event.education.title8')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onGetOrderInfo}
            >
              {t('event.education.column25')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={onClose}
            >
              {t('event.education.column26')}
            </AntButton>
          </div>
        ]}
      >
        <table className="table-custom">
          <colgroup>
            <col width="33%" />
            <col width="33%" />
            <col width="33%" />
          </colgroup>
          <tbody>
            <tr>
              <th className="text-center">{t('event.education.column36')}</th>
              <th className="text-center">{t('event.education.column22')}</th>
              <th className="text-center">{t('event.education.column37')}</th>
            </tr>
            {paymentSelects.map(eventRequireCode => (
              <tr key={eventRequireCode}>
                <td className="text-center">
                  {getPaymentInfo(eventRequireCode, 'campusKorName')}
                </td>
                <td className="text-center">
                  {getPaymentInfo(eventRequireCode, 'memKorName')}
                </td>
                <td className="text-center">
                  {Number(data1?.paymentAmount)?.toLocaleString()} {t('event.education.text3')}
                </td>
              </tr>
            ))}
            <tr>
              <th className="text-center" colSpan={2}>
                {t('event.education.column38')}
              </th>
              <th className="text-center">
                {(
                  Number(data1?.paymentAmount) * paymentSelects.length
                )?.toLocaleString()}{' '}
                {t('event.education.text3')}
              </th>
            </tr>
            <tr>
              <th className="text-center" colSpan={2}>
                {t('event.education.column39')}
              </th>
              <th className="text-center">
                <Select
                  className="w-100"
                  placeholder={t('common.button.select')}
                  value={installment}
                  onChange={(value) => setInstallment(value)}
                  disabled={
                    Number(data1?.paymentAmount) * paymentSelects.length < 50000
                  }
                >
                  {selectInstallment.map((text, index) => (
                    <Select.Option value={text} key={index}>
                      {text}
                    </Select.Option>
                  ))}
                </Select>
              </th>
            </tr>
          </tbody>
        </table>
        <h5 className="text-center mt-4">
          {t('event.education.text10')}{' '}
          {(Number(data1?.paymentAmount) * paymentSelects.length)?.toLocaleString()}{' '}
          {t('event.education.text11')}
        </h5>
      </Modal>

      {paymentProcessVisible &&
        <StudentPaymentProcessModal
          visible={paymentProcessVisible}
          onCancel={() => setPaymentProcessVisible(false)}
        />
      }
    </>
  );
};

export default ConfirmPaymentModal;
